// export const base_url = "http://localhost:5000";
// export const base_url = "https://backend-restaurants-production.up.railway.app";
// export const base_url = "https://floating-plains-43902.herokuapp.com";
export const base_url = "https://backend-restaurants.onrender.com";